import { api } from '@/api'
import { t } from '@lingui/core/macro'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

type ConnectWalletRequest = {
  walletAddress: string
  signature: string
  message: string
}

type UserWallet = {
  stakingPoints: number
  wallet: { linkedAt: string; stakeLamports: number; stakeUpdatedAt: string; walletAddress: string } | null
}

export const connectWalletToUser = (data: ConnectWalletRequest) => {
  return api.post('/user/wallet', data)
}

export const useConnectWallet = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: connectWalletToUser,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['DH_USER_LINKED_WALLET'] })
    },
    onError: (error) => {
      console.error('Wallet connection error:', error)
      toast.error(t`Failed to connect wallet. Please try again.`)
    }
  })
}

export const useFetchUserWallet = () => {
  return useQuery({
    queryKey: ['DH_USER_LINKED_WALLET'],
    queryFn: () => api.get<UserWallet>('/user/wallet')
  })
}

export const removeUserWallet = () => {
  return api.delete('/user/wallet')
}

export const useRemoveUserWallet = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: removeUserWallet,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['DH_USER_LINKED_WALLET'] })
    }
  })
}
